/* @generated from adl module ferovinum.sourcecontracts.suborder */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.sub_order` contract.
 */
export interface SubOrderSource {
  id: ferovinum_app_db.SubOrderId;
  purchaseOrderId: ferovinum_app_db.PurchaseOrderId;
  clientOrganisationId: ferovinum_app_db.OrganisationId;
  tradeSaleId: (ferovinum_app_db.PurchaseRequestId|null);
  invoiceNumber: string;
  status: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeSubOrderSource(
  input: {
    id: ferovinum_app_db.SubOrderId,
    purchaseOrderId: ferovinum_app_db.PurchaseOrderId,
    clientOrganisationId: ferovinum_app_db.OrganisationId,
    tradeSaleId: (ferovinum_app_db.PurchaseRequestId|null),
    invoiceNumber: string,
    status: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): SubOrderSource {
  return {
    id: input.id,
    purchaseOrderId: input.purchaseOrderId,
    clientOrganisationId: input.clientOrganisationId,
    tradeSaleId: input.tradeSaleId,
    invoiceNumber: input.invoiceNumber,
    status: input.status,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const SubOrderSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.suborder","decl":{"annotations":[{"value":{"modelName":"source__app_db.sub_order","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.sub_order` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SubOrderId"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseOrderId","default":{"kind":"nothing"},"name":"purchaseOrderId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseOrderId"}},"parameters":[]}},{"annotations":[],"serializedName":"clientOrganisationId","default":{"kind":"nothing"},"name":"clientOrganisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"tradeSaleId","default":{"kind":"nothing"},"name":"tradeSaleId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"invoiceNumber","default":{"kind":"nothing"},"name":"invoiceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"SubOrderSource","version":{"kind":"nothing"}}};

export const snSubOrderSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.suborder", name:"SubOrderSource"};

export function texprSubOrderSource(): ADL.ATypeExpr<SubOrderSource> {
  return {value : {typeRef : {kind: "reference", value : snSubOrderSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.suborder.SubOrderSource" : SubOrderSource_AST
};
